/**
 * One place for the "you're in the wrong part of town" wording so every
 * surface (the crew bounce, the Events banner, the not-found page) reads the
 * same way instead of inventing its own message.
 */

/** Session flag set when a non-crew account is sent to Events. */
export const CREW_BOUNCE_FLAG = "sf-crew-bounce";

/** The single line shown on Events after a crew-page bounce. */
export const CREW_BOUNCE_NOTE =
  "Wrong part of town — crew tools live behind the hangar door. Here's what's flying.";

/** Shown while we work out whether a viewer belongs on a crew page. */
export const ACCESS_CHECK_LINE = "Checking your access…";
export const ACCESS_CHECK_SUBLINE = "One moment — we're looking up your account.";

/** Leave the flag for the Events banner to pick up. Never throws. */
export function markCrewBounce() {
  try {
    sessionStorage.setItem(CREW_BOUNCE_FLAG, "1");
  } catch {
    /* private mode — the banner is optional */
  }
}

/** Read and clear the flag. Returns true when a banner should be shown. */
export function takeCrewBounce(): boolean {
  try {
    if (sessionStorage.getItem(CREW_BOUNCE_FLAG)) {
      sessionStorage.removeItem(CREW_BOUNCE_FLAG);
      return true;
    }
  } catch {
    /* private mode — skip the note */
  }
  return false;
}
